import { render, staticRenderFns } from "./GalleryThumbnailActionBar.vue?vue&type=template&id=2cd1afec&scoped=true"
import script from "./GalleryThumbnailActionBar.vue?vue&type=script&lang=ts"
export * from "./GalleryThumbnailActionBar.vue?vue&type=script&lang=ts"
import style0 from "./GalleryThumbnailActionBar.vue?vue&type=style&index=0&id=2cd1afec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd1afec",
  null
  
)

export default component.exports